import { useRef, useState } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

interface WallElementProps {
  position: [number, number, number];
  rotation: number;
  type: "normal" | "window";
  onClick: () => void;
  floor: number;
}

const WallElement: React.FC<WallElementProps> = ({
  position,
  rotation,
  type,
  onClick,
  floor,
}) => {
  const step = 1;
  const floorHeight = 3;
  const wallThickness = 0.2;
  const meshRef = useRef<THREE.Mesh>(null);
  const [hovered, setHovered] = useState(false);

  useFrame(() => {
    if (meshRef.current) {
      meshRef.current.rotation.y = rotation;
    }
  });

  const adjustedPosition = [
    position[0],
    (floor - 1) * floorHeight + 0.1, // Slightly above the grid
    position[2],
  ] as [number, number, number];
  return (
    <mesh
      ref={meshRef}
      position={adjustedPosition}
      onClick={onClick}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    >
      <boxGeometry args={[step, floorHeight, wallThickness]} />
      <meshStandardMaterial
        color={type === "normal" ? "#ffffff" : "#007AFF"}
        transparent={type === "window"}
        opacity={type === "window" ? 0.5 : 1}
        emissive={hovered ? "#f0f0f0" : "#ffffff"}
      />
    </mesh>
  );
};

export default WallElement;
